// tslint:disable
/**
 * JLIVE ADMIN API
 * JLIVE ADMIN API
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface EventAddressPoints
 */
export interface EventAddressPoints {
  /**
   * @type {string}
   * @memberof EventAddressPoints
   */
  address_additional_info?: string;
  /**
   * @type {string}
   * @memberof EventAddressPoints
   */
  address_name?: string;
  /**
   * @type {string}
   * @memberof EventAddressPoints
   */
  address1: string;
  /**
   * @type {string}
   * @memberof EventAddressPoints
   */
  address2?: string;
  /**
   * @type {string}
   * @memberof EventAddressPoints
   */
  postal_code?: string;
  /**
   * @type {string}
   * @memberof EventAddressPoints
   */
  state?: string;
  /**
   * @type {string}
   * @memberof EventAddressPoints
   */
  readonly state_display?: string;
  /**
   * @type {string}
   * @memberof EventAddressPoints
   */
  city: string;
  /**
   * @type {string}
   * @memberof EventAddressPoints
   */
  country: EventAddressPointsCountryEnum;
  /**
   * @type {string}
   * @memberof EventAddressPoints
   */
  readonly country_display?: string;
  /**
   * @type {number}
   * @memberof EventAddressPoints
   */
  lat: number;
  /**
   * @type {number}
   * @memberof EventAddressPoints
   */
  lng: number;
  /**
   * @type {boolean}
   * @memberof EventAddressPoints
   */
  wheelchair_accessible?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum EventAddressPointsCountryEnum {
  Ca = 'CA',
  Us = 'US',
}
